package com.havn.app.features.clients.domain

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json

private val qrPayloadJson = Json {
    encodeDefaults = false
    ignoreUnknownKeys = true
}

@Serializable
data class HavnClientQrPayload(
    @SerialName("sourceApp") val sourceApp: String = "HAVN",
    val contactId: String,
    val passKey: String
) {
    val clientId: String
        get() = contactId

    fun encode(): String = qrPayloadJson.encodeToString(
        HavnContactQrPayloadJson(
            s = sourceApp,
            v = 1,
            c = contactId,
            p = passKey.take(16)
        )
    )

    companion object {
        fun forClient(clientId: String, passKey: String): HavnClientQrPayload =
            HavnClientQrPayload(contactId = clientId, passKey = passKey)

        fun decode(raw: String): Result<HavnClientQrPayload> = runCatching {
            val payload = qrPayloadJson.decodeFromString<HavnContactQrPayloadJson>(raw.trim())
            val resolvedSource = payload.s ?: payload.sourceApp
            val resolvedContactId = payload.c ?: payload.contactId ?: payload.clientId
            val resolvedPassKey = payload.p ?: payload.passKey
            require(resolvedSource == "HAVN") { "This QR code is not from HAVN." }
            require(!resolvedContactId.isNullOrBlank()) { "This HAVN QR code is missing the contact id." }
            require(!resolvedPassKey.isNullOrBlank()) { "This HAVN QR code is missing the Wallet pass key." }
            HavnClientQrPayload(
                sourceApp = resolvedSource,
                contactId = resolvedContactId,
                passKey = resolvedPassKey
            )
        }
    }
}

@Serializable
private data class HavnContactQrPayloadJson(
    val s: String? = null,
    val v: Int? = null,
    val c: String? = null,
    val p: String? = null,
    @SerialName("sourceApp") val sourceApp: String? = null,
    val contactId: String? = null,
    val clientId: String? = null,
    val passKey: String? = null
)
